import { render, staticRenderFns } from "./UpdateCardDetails.vue?vue&type=template&id=6ca251c8&scoped=true&"
import script from "./UpdateCardDetails.vue?vue&type=script&lang=js&"
export * from "./UpdateCardDetails.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCardDetails.vue?vue&type=style&index=0&id=6ca251c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca251c8",
  null
  
)

export default component.exports